import { render, staticRenderFns } from "./PT050ShoppingCartParts.vue?vue&type=template&id=3c9d97d6&"
import script from "./PT050ShoppingCartParts.vue?vue&type=script&lang=js&"
export * from "./PT050ShoppingCartParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports